const ipfs = new IPFS({
  start: false,
  loadRefs: true
})

export { ipfs }
